import React from 'react';
import './styles.module.scss';
import { FormInputRadio, FormInputCheckboxLabel } from '../StyledComponents';

const Checkbox = ({
  placeholder,
  checked,
  onChange,
  onChangeDefault,
  value,
  marginRight = '10px',
}) => {
  return (
    <FormInputCheckboxLabel className="containerCheckbox">
      <FormInputRadio
        marginRight={marginRight}
        type="checkbox"
        checked={checked}
        onChange={() => {
          if (onChangeDefault) onChangeDefault(value);
          onChange(value);
        }}
      />
      <span className="checkmark">{placeholder}</span>
    </FormInputCheckboxLabel>
  );
};

export default Checkbox;
